import { FilterTopic } from '../../FilterMenu/types';
import { SortItemType, useSort } from '../../../hooks/useSort';
import dynamic from 'next/dynamic';
import type { FC } from 'react';

const SortAndFilterComponent = dynamic(
  () => import('components/SortAndFilter').then((m: any) => m.SortAndFilter),
  { ssr: true },
) as any;

type SortAndFilterProps = {
  searchItemLabels: Record<string, string>;
  sortItemType: SortItemType;
  currentSort: string;
  totalSearchResult: number;
  currentSearchCategory: string;
  onSort: (sortMethod: string) => void;
  onFilter: () => void;
  selectedFilters: FilterTopic[];
};

const SortAndFilter: FC<SortAndFilterProps> = ({
  searchItemLabels,
  sortItemType,
  currentSort,
  totalSearchResult,
  currentSearchCategory,
  onSort,
  onFilter,
  selectedFilters,
}) => {
  const { getAvailableSortMethods } = useSort(SortItemType.ANY);
  return (
    <SortAndFilterComponent
      id="sort-controls"
      labels={searchItemLabels}
      options={getAvailableSortMethods(sortItemType).map((m) => ({
        label: searchItemLabels[`sort_${m}`] || m,
        value: m,
      }))}
      selectedSort={currentSort}
      currentCount={totalSearchResult}
      showFilter={currentSearchCategory !== 'ALL' && currentSearchCategory !== 'ARTICLES'}
      onSort={onSort}
      onFilter={onFilter}
      currentFiltersCount={selectedFilters.length}
    />
  );
};

export default SortAndFilter;
